const _temp0 = require("./activity-3-part-1-audrey.vue");
const _temp1 = require("./activity-3-part-1-beulah.vue");
const _temp2 = require("./activity-3-part-1-columbus.vue");
const _temp3 = require("./activity-3-part-1-elaine.vue");
const _temp4 = require("./activity-3-part-1-maxine.vue");
const _temp5 = require("./activity-3-part-1-shirley.vue");
module.exports = {
  "audrey": _temp0,
  "beulah": _temp1,
  "columbus": _temp2,
  "elaine": _temp3,
  "maxine": _temp4,
  "shirley": _temp5
}